import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">常见问答</h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">关于51cg吃瓜平台与热门人物的常见问题解答</p>
        <div className="grid gap-3 md:gap-4">
          {faqData.map((item, i) => (
            <details key={i} className="group bg-background-50 rounded-lg border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200/40 transition-colors list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-200 pr-4">{item.question}</h3>
                <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}